<!-- the infoboard for cell phone only --->
<template>
    <div class="infoboard" style="transform: scale(1) rotate(0deg);">
        <div class="body">
            <!-- 频道区域 -->
            <profile-section :avatar-size="32" :profile="profile" :location="e.location"></profile-section>
            <div class="margin-bottom-8px"></div>
            <el-divider></el-divider>
            <div class="caption-panel">
                <!-- caption：主题描述 -->
                <caption_ :url="profile.avatar"
                          :name="profile.name"
                          :code="profile.code"
                          :text="e.caption"
                          :timestamp="e.upload_ts"
                          :avatar-size="32">
                    <div class="margin-top-8px"></div>
                </caption_>
            </div>
            <div class="margin-bottom-2px"></div>
            <el-divider></el-divider>
            <!-- 喜欢区域 -->
            <div style="padding: 8px 0px 0px 0px; height:6%;">
                <phone-favorite :e="e"></phone-favorite>
            </div>
            <!-- 滚动区域 slogan 以及说明区域 -->
            <div style="padding: 12px 0px 0px 0px;" align="center">
                <slogan></slogan>
                <!-- notice -->
                <div class="notice" style="">
                    <i class="iconfont icon-sy-laba" style="font-size:18px"></i>
                    <div class="notice-text">1积分抵扣￥1 <span v-if="isShowWatermark">| 下载的视频图片不含火酷水印</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getProfile} from '../../../data/profile';
    import ProfileSection from "./ProfileSection";
    import Favorite from "./Favorite";
    import {Entity} from "../../../utils";
    import Caption_ from '@/components/comments/Caption'
    import PhoneFavorite from "./PhoneFavorite";
    import {getMainComments} from "../../../data/comment";
    import {ShowEntityMode} from "../../../utils";

    export default {
        name: "PhoneInfoboard",
        components: {
            ProfileSection,
            Caption_,
            PhoneFavorite,
        },
        props: {
            e: Object,  // entity
        },
        data() {
            return {
                // 给一个模拟的初始值实现预加载，避免页面留白
                profile: {
                    avatar: require('@/assets/transparent-gray_320x320.png'),  // 使用预加载图片
                    name: null,
                    code: null
                }
            }
        },
        created(){
            // 如何绑定 ES6 export module 中的 this....... TODO refactor this into Profile component
            getProfile.bind(this)(this.e.profile_code).then((profile)=>{
                console.log(profile);
                if(this.$store.getters.getShowEntityMode() !== ShowEntityMode.PopupPageMode) // title 只在 single page 中显示，弹窗不显示的
                    this.$store.commit('setTitle', profile.name);
                this.profile = profile;
                console.log(`profile section created, fetched profile via profile code ${this.e.profile_code} is ${JSON.stringify(this.profile)}`);
            }).catch((error)=>{
                console.log(error);
            });
        },
        computed: {
            // @deprecated 现在通过预加载（如果没有加载成功则使用空白模板显示）的方式提前显示，页面尽量不留白
            isProfileLoaded: function(){
                return this.profile !== null ? true: false;
            },

            isShowWatermark: function(){
                return this.$store.state.displayCtrl !== null ? this.$store.state.displayCtrl.watermark : false;
            }
        }
    }
</script>

<style scoped>

    .infoboard{
        width: 100%;
        height: 100%;
    }

    .infoboard .body{
        padding: 15px;
        display: flex;
        flex-direction: column;
        background-color: white;
        transform: scale(1) rotate(0deg);
        background-color: rgb(250, 250, 250);
    }

    /* mini phone screen */
    @media (max-width: 350px){
        .infoboard .body{
            padding: 10px;
        }
    }

    /* 自定义 divider 的 margin */
    .el-divider--horizontal{
        height: 1px;
        margin-top: 0px;
        margin-bottom: 0px;
    }

    /* 消除 el-card 默认的 1px gray border */
    .el-card {
        border: 0px;
    }

    /deep/ .el-card__body{
        background-color: rgb(250, 250, 250) !important;
    }

    .caption-panel {
        width: 100%;
        width: 100%;
        background-color: rgb(250, 250, 250);
    }

    .notice {
        display:inline-flex;
        align-items: center;
        margin-top:8px
    }

    .notice-text{
        color:#210B61;
        margin-left: 4px;
    }

    /* mini phone screen */
    @media (max-width: 350px){
        .notice-text{
            margin-left: 2px !important;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/entity/infoboard/PhoneInfoboard.vue